import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4659647c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Pagination" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "Pagination__page active" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["Pagination__control control--left", { disabled: _ctx.currentPage <= 1 }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitChange(1)))
    }, _hoisted_4, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["Pagination__control", { disabled: _ctx.currentPage <= 1 }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitChange(_ctx.currentPage - 1)))
    }, _hoisted_6, 2),
    (_ctx.totalPages <= 5)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.totalPages, (page) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["Pagination__page", { active: page === _ctx.currentPage }]),
            key: page,
            onClick: ($event: any) => (_ctx.emitChange(page))
          }, _toDisplayString(page), 11, _hoisted_7))
        }), 128))
      : (_ctx.currentPage < 3)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(3, (page) => {
            return _createElementVNode("div", {
              class: _normalizeClass(["Pagination__page", { active: page === _ctx.currentPage }]),
              key: page,
              onClick: ($event: any) => (_ctx.emitChange(page))
            }, _toDisplayString(page), 11, _hoisted_8)
          }), 64))
        : (_ctx.currentPage > _ctx.totalPages - 2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", {
                class: _normalizeClass(["Pagination__page", { active: _ctx.currentPage === _ctx.totalPages - 2 }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitChange(_ctx.totalPages - 2)))
              }, _toDisplayString(_ctx.totalPages - 2), 3),
              _createElementVNode("div", {
                class: _normalizeClass(["Pagination__page", { active: _ctx.currentPage === _ctx.totalPages - 1 }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitChange(_ctx.totalPages - 1)))
              }, _toDisplayString(_ctx.totalPages - 1), 3),
              _createElementVNode("div", {
                class: _normalizeClass(["Pagination__page", { active: _ctx.currentPage === _ctx.totalPages }]),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.emitChange(_ctx.totalPages)))
              }, _toDisplayString(_ctx.totalPages), 3)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", {
                class: "Pagination__page",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emitChange(_ctx.currentPage - 1)))
              }, _toDisplayString(_ctx.currentPage - 1), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.currentPage), 1),
              _createElementVNode("div", {
                class: "Pagination__page",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.emitChange(_ctx.currentPage + 1)))
              }, _toDisplayString(_ctx.currentPage + 1), 1)
            ], 64)),
    _createElementVNode("div", {
      class: _normalizeClass(["Pagination__control", { disabled: _ctx.currentPage >= _ctx.totalPages }]),
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.emitChange(_ctx.currentPage + 1)))
    }, _hoisted_11, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["Pagination__control control--right", { disabled: _ctx.currentPage >= _ctx.totalPages }]),
      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.emitChange(_ctx.totalPages)))
    }, _hoisted_14, 2)
  ]))
}